import { Button, Flex, Modal, Textarea } from "src/elements";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { useAtom } from "jotai";
import type { StatusModalData } from "./store/atoms";
import { statusModalDataAtom } from "./store/atoms";
import { useToasts } from "src/components/Toasts";

const StatusTextarea = styled(Textarea)`
  font-family: monospace;
`;

export const StatusModal = () => {
  const [statusData, setStatusData] = useAtom(statusModalDataAtom);

  useEffect(() => {
    return () => {
      setStatusData(null);
    };
  }, []);

  return statusData ? <StatusModalInner {...statusData} /> : null;
};

type StatusModalProps = StatusModalData;

const StatusModalInner = ({ title, content, onContinue }: StatusModalProps) => {
  const [copied, setCopied] = useState(false);
  const { toast } = useToasts();

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast({ title: "Failed to copy text", error: err });
    }
  };

  return (
    <Modal name="StatusModal" title={title} width="600px">
      <Flex column padding="20px" gap="10px">
        <StatusTextarea title={"Details"} value={content} minHeight="500px" />

        <Flex justify="right" gap="10px">
          {onContinue && (
            <Button color="primary" onClick={onContinue} iconLeft={{ name: "arrowRight" }}>
              Continue
            </Button>
          )}
          <Button
            color={copied ? "success" : "primary"}
            onClick={handleCopyToClipboard}
            iconLeft={{ name: copied ? "checkmark" : "copyToClipboard" }}
          >
            {copied ? "Copied!" : "Copy to Clipboard"}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
